// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 938) return "static/chunks/938-f4aae34bdd23f154.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"341":"b9b26c3f","538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"146":"0efee949553e644c","341":"2c6dbd7c783c6675","377":"04cc4f7ac08782c1","415":"67a6f87f942e05e5","538":"cd140c3d731aed86","539":"9843b05961184121","767":"f972996417007120","983":"74000e5117bfeb38"}[chunkId] + ".js";
};